import getGoals from "@/assets/ts/proposal/steps/goals";
import getSDG from "@/assets/ts/proposal/steps/sdg";
import getOrg from "@/assets/ts/proposal/steps/organization";
const form =
{
  goals: getGoals(),
  sdg: getSDG(),
  organization: getOrg()  
}

export default form
